import React from "react";

export const incidentTypes = [
  {
    incident: "Lost time injury frequecy Rate(LTIFR)",
    category: "Employees",
    current: 0,
    previous: 0,
  },
  {
    incident: "Lost time injury frequecy Rate(LTIFR)",
    category: "Workers",
    current: 0,
    previous: 0,
  },
  {
    incident: "Total recordable work-related",
    category: "Employees",
    current: 0,
    previous: 0,
  },
  {
    incident: "Total recordable work-related",
    category: "Workers",
    current: 0,
    previous: 0,
  },
  {
    incident: "No. of fatalities",
    category: "Employees",
    current: 0,
    previous: 0,
  },
  {
    incident: "No. of fatalities",
    category: "Workers",
    current: 0,
    previous: 0,
  },
  {
    incident: "High consequence work-related injury or ill-health",
    category: "Employees",
    current: 0,
    previous: 0,
  },
  {
    incident: "High consequence work-related injury or ill-health",
    category: "Workers",
    current: 0,
    previous: 0,
  },
];

// export const incidentTypes = {
//   employee: {
//     current: {
//       "Lost time injury frequecy Rate(LTIFR)": "",
//       "Total recordable work-related": "",
//       "No. of fatalities": "",
//       "High consequence work-related injury or ill-health": "",
//     },
//     previous: {
//       "Lost time injury frequecy Rate(LTIFR)": "",
//       "Total recordable work-related": "",
//       "No. of fatalities": "",
//       "High consequence work-related injury or ill-health": "",
//     },
//   },
//   worker: {
//     current: {
//       "Lost time injury frequecy Rate(LTIFR)": "",
//       "Total recordable work-related": "",
//       "No. of fatalities": "",
//       "High consequence work-related injury or ill-health": "",
//     },
//     previous: {
//       "Lost time injury frequecy Rate(LTIFR)": "",
//       "Total recordable work-related": "",
//       "No. of fatalities": "",
//       "High consequence work-related injury or ill-health": "",
//     },
//   },
// };

const SafetyIncidentTable = ({ safetyData, setSafetyData }) => {
  const categories = [
    "Lost time injury frequecy Rate(LTIFR)",
    "Total recordable work-related",
    "No. of fatalities",
    "High consequence work-related injury or ill-health",
  ];
  const fields = [
    { label: "Fatalities", key: "fatal" },
    { label: "High consequence work-related injury", key: "high_consequence" },
    { label: "Recordable work-related injury", key: "recordable" },
  ];

  const handleChange = (index, key, value) => {
    const updated = [...safetyData];
    updated[index] = { ...updated[index], [key]: value };
    setSafetyData(updated);
  };
  const cellStyle = {
    padding: "8px",
    border: "1px solid #000",
    textAlign: "center",
  };
  const cellStyleFilled = {
    padding: "8px",
    border: "1px solid #000",
    textAlign: "center",
    backgroundColor: "#d8cbd4",
  };

  const rendertable = () => {
    const elements = [];
    for (let i = 0; i < safetyData.length; i += 2) {
      const first = safetyData[i]; // even index
      const second = safetyData[i + 1]; // next item (odd index) if exists

      elements.push(
        <>
          <tr key={`${first.incident}-${first.category}-1`}>
            <td rowSpan={2} style={cell}>
              <strong>
                {first.incident.charAt(0).toUpperCase() +
                  first.incident.slice(1)}
              </strong>
            </td>
            <td style={cellStyleFilled}>{first.category}</td>
            <td style={cellStyle}>
              <input
                type="text"
                placeholder="Current FY"
                value={safetyData[i].current}
                onChange={(e) => handleChange(i, "current", e.target.value)}
                style={inputStyle}
              />
            </td>
            <td style={cellStyle}>
              <input
                type="text"
                placeholder="Previous FY"
                value={safetyData[i].previous}
                onChange={(e) => handleChange(i, "previous", e.target.value)}
                style={inputStyle}
              />
            </td>
          </tr>

          <tr key={`${first.incident}-${second.category}-2`}>
            <td style={cellStyleFilled}>{second.category}</td>
            <td style={cellStyle}>
              <input
                type="text"
                placeholder="Current FY"
                value={safetyData[i + 1].current}
                onChange={(e) => handleChange(i + 1, "current", e.target.value)}
                style={inputStyle}
              />
            </td>
            <td style={cellStyle}>
              <input
                type="text"
                placeholder="Previous FY"
                value={safetyData[i + 1].previous}
                onChange={(e) =>
                  handleChange(i + 1, "previous", e.target.value)
                }
                style={inputStyle}
              />
            </td>
          </tr>
        </>
      );
    }
    return elements;
  };
  return (
    <div
      style={{
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#d8cbd4" }}>
            <th style={cellHeader}>Safety Incident / Number</th>
            <th style={cellHeader}>Cetegory</th>
            <th style={cellHeader}>Current Financial Year</th>
            <th style={cellHeader}>Previous Financial Year</th>
          </tr>
        </thead>
        <tbody>
          {rendertable()}

          {/* {safetyData.map((item) => (
            <>
              <tr key={`${item.incident}-1-${item.category}`}>
                <td rowSpan={2} style={cell}>
                  <strong>
                    {item.incident.charAt(0).toUpperCase() + item.incident.slice(1)}
                  </strong>
                </td>
                <td style={cellStyleFilled}>{item.Cetegory}</td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Current FY"
                    value={safetyData.employee.current[category]}
                    onChange={(e) =>
                      handleChange(
                        "employee",
                        "current",
                        category,
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Previous FY"
                    value={safetyData.employee.previous[category]}
                    onChange={(e) =>
                      handleChange(
                        "employee",
                        "previous",
                        category,
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>

              <tr key={`${category}-2`}>
                <td style={cellStyleFilled}>Workers</td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Current FY"
                    value={safetyData.worker.current[category]}
                    onChange={(e) =>
                      handleChange(
                        "worker",
                        "current",
                        category,
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>
                <td style={cellStyle}>
                  <input
                    type="text"
                    placeholder="Previous FY"
                    value={safetyData.worker.previous[category]}
                    onChange={(e) =>
                      handleChange(
                        "worker",
                        "previous",
                        category,
                        e.target.value
                      )
                    }
                    style={inputStyle}
                  />
                </td>
              </tr>
            </>
          ))} */}
        </tbody>
      </table>
    </div>
  );
};

const cellHeader = {
  border: "1px solid #000",
  padding: "8px",
  textAlign: "center",
  fontWeight: "bold",
};

const cell = {
  border: "1px solid #ccc",
  padding: "6px",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  padding: "5px",
  borderRadius: "4px",
  border: "1px solid gray",
};

export default SafetyIncidentTable;
